/**
 * Shared z-index tokens for overlay layering across the app.
 *
 * Radix defaults (``PopoverContent``/``DialogContent`` at ``z-50``, ``DialogOverlay``
 * bumped via ``z-[9999]``) are not enforced by these constants, but callers should
 * use the tokens below instead of ad-hoc numbers so overlay relationships stay
 * greppable and consistent.
 *
 * Ordering (lowest → highest):
 *
 * - ``STICKY_HEADER`` — in-document sticky headers.
 * - ``RADIX_POPOVER`` — Radix popover content default (documented here only).
 * - ``VERDICT_HINT`` — verdict feature hint floater over the chat composer.
 * - ``APP_DIALOG`` — modal dialogs / full-screen overlays.
 */
export const Z_INDEX = {
  STICKY_HEADER: 9,
  // ``RADIX_POPOVER`` is documentation-only: the value mirrors Radix's internal
  // ``z-50`` applied to ``PopoverContent`` so surrounding overlays can reason
  // about layering. Do NOT set ``Z_INDEX.RADIX_POPOVER`` on popover content
  // directly — Radix manages that styling itself and re-applying it can cause
  // double-stacking issues.
  RADIX_POPOVER: 50,
  VERDICT_HINT: 80,
  APP_DIALOG: 9999
} as const

export type ZIndexToken = (typeof Z_INDEX)[keyof typeof Z_INDEX]
